// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__tHIAG","textError":"styles_textError__fdEMw"};